import { PrimaryButton } from "../../../../components/Modules/PrimaryButton";
import { SecondaryButton } from "../../../../components/Modules/SecondaryButton";
import { FormNavigationProps } from "../types/SurveyTypes";

const FormNavigation: React.FC<FormNavigationProps> = ({
  currentSection,
  setCurrentSection,
  design,
  returnAnswers,
  goToNextSection,
  GeneralFunctions,
  themeManager,
}) => {
  return (
    <div className="q_feedback_buttons">
      <SecondaryButton
        children={currentSection > 0 ? "Previous" : "Cancel"}
        onClick={(e) => {
          GeneralFunctions.fireTrackingEvent(
            "quest_survey_secondary_button_clicked",
            "survey"
          );
          e.preventDefault();
          e.stopPropagation();
          if (currentSection > 0) {
            setCurrentSection(currentSection - 1);
          } else {
          }
        }}
        style={themeManager.getButtonStyles().secondary}
      />
      <PrimaryButton
        type="button"
        style={themeManager.getButtonStyles().primary}
        onClick={() => {
          GeneralFunctions.fireTrackingEvent(
            "quest_survey_primary_button_clicked",
            "survey"
          );
          const totalSections = Object.keys(design);

          if (currentSection < totalSections.length - 1) {
            GeneralFunctions.fireTrackingEvent(
              "quest_gamifiedquiz_next_section_button_clicked",
              "gamifiedquiz"
            );
            setCurrentSection(currentSection + 1);
          } else if (currentSection >= totalSections.length - 1) {
            returnAnswers();
          }
        }}
        children={
          currentSection >= design.length - 1 ? "Submit" : "Next"
        }
        disabled={!goToNextSection}
      />
    </div>
  );
};

export default FormNavigation;
